const profileOptionsForAll = [
  // { value: 1, label: "Please Select the type uprights" },
  { value: 2, label: "Input Sectional Properties Manually" },
  { value: 4, label: "Option1 - 80mm uprights, Standard 2.0mmThk" },
  { value: 5, label: "Option1 - 80mm uprights, 2.3mmThk" },
  { value: 7, label: "Option2 - 80mm uprights, 2.0mmThk" },
  { value: 8, label: "Option2 - 80mm uprights, 2.3mmThk" },
  { value: 12, label: "Option1 - 100mm uprights, Standard 2.0mmThk" },
  { value: 14, label: "Option1 - 120mm uprights, 2.5mmThk" },
  { value: 15, label: "Option2 - 100mm uprights, Standard 2.0mmThk" },
  { value: 17, label: "Option2 - 120mm uprights, 2.5mmThk" },
  { value: 21, label: "Sperrin - 80mm uprights, MK2, 2.3mm Thk" },
  { value: 22, label: "NEW - Option1 - 100mm MK3 uprights - 2.0mm THK" },
  { value: 24, label: "NEW - Option1 - 120mm MK3 uprights - 2.0mm THK" },
  { value: 25, label: "NEW - Option1 - 120mm MK3 uprights - 2.5mm THK" },
  { value: 26, label: "Option 1 - 140mm MK3 uprights - 2.5mmTHK" },
  { value: 27, label: "Option 1 - 160mm MK3 uprights - 2.5mmTHK" },
];

const profileOptionsForOption1 = [
  // { value: 1, label: "Please Select the type uprights" },
  { value: 2, label: "Input Sectional Properties Manually" },
  { value: 4, label: "Option1 - 80mm uprights, Standard 2.0mmThk" },
  { value: 5, label: "Option1 - 80mm uprights, 2.3mmThk" },
  { value: 12, label: "Option1 - 100mm uprights, Standard 2.0mmThk" },
  { value: 14, label: "Option1 - 120mm uprights, 2.5mmThk" },
  { value: 21, label: "Sperrin - 80mm uprights, MK2, 2.3mm Thk" },
  { value: 22, label: "NEW - Option1 - 100mm MK3 uprights - 2.0mm THK" },
  { value: 24, label: "NEW - Option1 - 120mm MK3 uprights - 2.0mm THK" },
  { value: 25, label: "NEW - Option1 - 120mm MK3 uprights - 2.5mm THK" },
  { value: 26, label: "Option 1 - 140mm MK3 uprights - 2.5mmTHK" },
  { value: 27, label: "Option 1 - 160mm MK3 uprights - 2.5mmTHK" },
];

const profileOptionsForOption2 = [
  // { value: 1, label: "Please Select the type uprights" },
  { value: 2, label: "Input Sectional Properties Manually" },
  { value: 7, label: "Option2 - 80mm uprights, 2.0mmThk" },
  { value: 8, label: "Option2 - 80mm uprights, 2.3mmThk" },
  { value: 15, label: "Option2 - 100mm uprights, Standard 2.0mmThk" },
  { value: 17, label: "Option2 - 120mm uprights, 2.5mmThk" },
];

const profileMenuOptions = [
  { value: 1, label: "All" },
  { value: 2, label: "Option 1" },
  { value: 3, label: "Option 2" },
];

export {
  profileMenuOptions,
  profileOptionsForAll,
  profileOptionsForOption1,
  profileOptionsForOption2,
};
